import React from "react";
import { useDeleteCatalogueByIdMutation, useGetCatalogueQuery } from "store/abcoApi";

import PageLoader from "components/general/PageLoader";
import { Box } from "components/ui";

import Seo from "components/general/Seo";
import StockCollectionListingScreen from "screens/StockCollectionListingScreen";
export default function Page() {
	const [pageNumber, setPageNumber] = React.useState(1);

	const { data, isLoading, isFetching } = useGetCatalogueQuery({ pageNumber });
	const [deleteCatalogue] = useDeleteCatalogueByIdMutation();

	if (isLoading || data == null) {
		return (
			<Box minHeight={150}>
				<PageLoader />
			</Box>
		);
	}

	return (
		<Box>
			<Seo title="Admin | Catalogue | Abconet" description="Organize and update product listings, categories, and specifications in the catalogue management section." />
			<StockCollectionListingScreen isAdmin data={data} deleteCatalogue={deleteCatalogue} setPageNumber={setPageNumber} type="catalogues" />
		</Box>
	);
}
